import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MdSnackBar } from '@angular/material';

import { TdDialogService, TdLoadingService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';

import 'rxjs/add/operator/toPromise';

@Component({
  selector: 'shelf-form',
  providers: [StorageService],
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class ShelfFormComponent implements OnInit {

  action: string;
  shelfName: string;
  shelf: any = {};

  shelfs: string[] = [];
  filteredShelfs: string[];
  chipAddition: boolean = true;
  chipRemoval: boolean = true;
 
  constructor(private _storageService: StorageService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _snackBarService: MdSnackBar,
              private _loadingService: TdLoadingService,
              private _dialogService: TdDialogService) {}

  goBack(): void {
    this._router.navigate(['/shelf']);
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: {shelfName: string}) => {
      this.shelfName = params.shelfName;
      if (this.shelfName) {
        this.load();
      } else {
        this.shelfs = [];
      }
    });
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('shelf.form');
      this.shelf = await this._storageService.getContainer(this.shelfName).toPromise();
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error loading the shelf'});
    } finally {
      this._loadingService.resolve('shelf.form');
    }
  }

  async save(): Promise<void> {
    try {
      this._loadingService.register('shelf.form');    
      this.shelf.containerStatus = 'OPEN';
      this.shelf.containerType = 'SHELF';
      await this._storageService.updateContainer(this.shelf, false).toPromise();
      this._snackBarService.open('Shelf saved', 'Ok');
      this.goBack();
    } catch (error) {
      this._dialogService.openAlert({title: 'There was an error saving the shelf', message: error.message});
    } finally {
      this._loadingService.resolve('shelf.form');
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/shelf/form/form.component.ts